export default {
    medals:'{n} Medal | {n} Medals | {n} Medals',
    acquiredAmount:'{number} Medals Acquired',
    upgradableType:'Upgradable medals',
    achivementType:'Achievement medals',
    seriesType:'Exclusive medals',
    limitedType:'Event medals',
    acquire:'Acquire',
    equip:'Equip medal',
    equipped:'Equipped',
    acquiredDate:'Acquired on {date}',
    more:'More'
} 